import React from 'react';
import styled from '@emotion/styled';
import { colors } from 'constants/colors';
export default (props) => {
    const { code, badge, src, srcSet, size, marginBottom, withBorder, borderColor = colors.ffffff, } = props;
    const fraction = 3.0;
    return (React.createElement(Image, null,
        React.createElement(Img, { src: src, srcSet: srcSet || '', width: `${size}px`, height: `${size}px`, marginBottom: marginBottom, "data-border": withBorder, borderColor: borderColor }),
        badge ? (React.createElement(Badge, { src: badge === 'camera_new'
                ? '/assets/img/common/flags/' + code + '.svg'
                : '/assets/img/common/flags/' + code + '.png', width: size / fraction, photoSize: size })) : null));
};
const Image = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
`;
const Badge = styled.img `
  box-sizing: border-box;
  width: ${(props) => props.width}px;
  position: absolute;
  bottom: -5%;
  right: calc(50% - ${(props) => props.photoSize / 2}px);
`;
const Img = styled.img `
  box-sizing: border-box;
  border-radius: 50%;
  margin-bottom: ${(props) => props.marginBottom}px;

  &[data-border='true'] {
    border: 2px solid ${(props) => props.borderColor};
  }
`;
